<template>
  <div id="app">
    <component :is="headerComponent" />

    <div class="page-content">
      <router-view />
    </div>

    <component :is="footerComponent" />
  </div>
</template>

<script>
import HeaderMenu from "@/views/admin/HeaderMenu.vue";
import FooterComponent from "@/views/admin/FooterComponent.vue";
import PublicHeader from "@/components/PublicHeader.vue";
import PublicFooter from "@/components/PublicFooter.vue";

export default {
  name: "App",
  components: {
    HeaderMenu,
    FooterComponent,
    PublicHeader,
    PublicFooter
  },
  computed: {
    isAdmin() {
      return this.$route.path.startsWith("/admin") && this.$route.path !== "/admin/login";
    },
    isLogin() {
      return this.$route.path === "/admin/login";
    },
    headerComponent() {
      if (this.isAdmin) return "HeaderMenu";
      if (this.isLogin) return null;
      return "PublicHeader";
    },
    footerComponent() {
      if (this.isAdmin) return "FooterComponent";
      if (this.isLogin) return null;
      return "PublicFooter";
    }
  }

};
</script>


<style>
html, body, #app {

  margin: 0;
  padding: 0;
  background-color:rgb(2, 7, 22);
  overflow-x: hidden;
  overflow-y: auto;
  

}

/* Glavni Flex wrapper */
#app {
  display: flex;
  flex-direction: column;
}

/* Glavni sadržaj gura footer dole */
.page-content {
  flex: 1 0 auto;
  padding-bottom: 20px; /* opcionalno, da ne dodiruje footer */
}

footer {
  flex-shrink: 0;
}

.code {
  color: wheat !important;
}
.accrodion-content h4 {
  margin-top: 50px;
}
</style>
